import React, { createContext, useContext, useEffect, useState } from 'react'
import { darkTheme } from './Color';
import { useTranslation } from 'react-i18next';

const ThemeContext = createContext();

export const useTheme = () => {
  return useContext(ThemeContext);
};
const ThemeProvider = ({children}) => {
    const root = document.documentElement;
  const [theme, setTheme] = useState(darkTheme);
  const {t} = useTranslation()

  Object.entries(theme)?.forEach(([key, value]) => {
    root.style.setProperty(`--${key}`, value);
  });
useEffect(()=>{
    document.title = t('title')
},[])
  return (
    <ThemeContext.Provider value={{theme}}>
        {children}
    </ThemeContext.Provider>
  )
}

export default ThemeProvider